export const animals = [
    "Dog",
    "cat",
    "Rabbit",
    "cow",
    "chicken",
    "cattle",
    "mammal",
    "Cattle",
    "Horse",
    "Turtle",
    "Hamster",
    "Lion",
    "Fox",
    "Fox ",
    "Goat",
    "Deer",
    "Chicken",
    "Monkey",
    "Birds",
    "Sheep",
    "Pigs",
    "Fowl",
    "Duck",
    "Other Birds",
    "snake",
    "horse",
    "duck",
    "donkey",
    "Donkey",
    "mules",
    "Elephant",
    "Elk",
    "Wapiti",
    "Mule deer",
    "Black-tailed deer",
    "Sika deer",
    "White-tailed deer",
    "Reindeer",
    "Moos",
    "Tiger",
    "Goats",
    "Buffaloes",
    "Dogs",
    "Wolves",
    "Hyaenas",
    "Pig",
  ];

  export const sickness = [
    "Torticollis",
    "Feels stiff",
    "Tears",
    "bloody discharge",
    "Facial edema",
    "Urine retention",
    "Nausea",
    "Weight Loss",
    "Not eating",
    "Blurry vision",
    "Roughened",
    "Ulcer on gum",
    "Sores on lip",
    "Painfull to touch",
    "Severe kerititis",
    "extending its neck",
    "Malaise",
    "rapid pulse and heart rates",
    "Splenomegaly",
    "Vaginal Discharge",
    "Head Shking",
    "Loss of Appetite",
    "Muscle Trembling",
    "Heavy infection",
    "drinking polluted water",
    "swollen lymph nodes",
    "Rhinorrhea",
    "Loss of consciousness",
    "Sinuses",
    "Behaviour change",
    "Stomach growling",
    "Stress",
    "Scaly patches of skin",
    "Pot belly",
    "Severe inflammation",
    "Ulcerated muscle",
    "Septicemia",
    "Swelling of eye",
    "Dizzines",
    "drooling",
    "Ruminal stasis",
    "rectal bleeding",
    "Tear production",
    "General malaise",
    "Swollen left abdomen",
    "Nasal Bleeding",
    "Lumps",
    "Deability",
    "Pink eye",
    "Swollen Eyelids",
    "Loss of activity",
    "Irritation",
    "nasal discharge",
    "Shaking head",
    "Short stature",
    "Frequent eye Infections",
    "Underdeveloped muscles",
    "lymphosarcoma",
    "swollen purple wattle",
    "White mark on the muscle",
    "Painfull",
    "Undigested seeds",
    "Thick Crusting",
    "Nosebleeds",
    "Sore",
    "Infection",
    " abortion at the end of gestation",
    "Stumbling",
    "Mortality varies",
    "Paresis",
    "lameness in affected leg",
    "Short term lethargy",
    "Hardness",
    "Oral lesion",
    "Excess sleeping",
    "Paralysis",
    "Ocular discharge",
    "Malpresentation",
    "Radip onset",
    "Erythema",
    "Rump",
    "Anaemia",
    "Abdminal pain",
    "Loss of appettite",
    "Labored breathing",
    "swelling problem",
    "Muscle aches",
    "weak calves",
    "Convulsion",
    "Abnormal behaviour",
    "Trachea",
    "Week legs",
    "Larynx",
    "Small size",
    "Lack of pigmentation",
    "Unusally thin",
    "Bluish white opacity",
    "Coughing ",
    "Distended chest",
    "Cornea become cloudy",
    "Poor Appetite",
    "Abdominal destention",
    "Swelling on leg",
    "Pain on leg",
    "Bloody Urine",
    "Limp",
    "Bloody discharge",
    "Sloughing of the tail",
    "Holding limbs off the ground",
    "Decreased appetite",
    "Gastritis",
    "Pain",
    "Kicking",
    "Round patches",
    "Liver disease",
    "Ring shaped Lesion",
    " increased passing gas",
    "distended stomach",
    "Constipation",
    "Thickening of skin",
    "Skin Lesion",
    "Feather Plucking",
    "Foul Smelling",
    "wheezing",
    "Facial muscle twitching",
    "Lying Down",
    "Watery faeces",
    "Excitability",
    "reduced appetite",
    "Green Dropping",
    "Reduce Energy",
    "droopy wings",
    "Inability of Swalllon Feeding",
    "Reduce feed",
    "Hock joint",
    "Stiff",
    "Poor conformation",
    "Trouble walking",
    "Firm",
    "egg production decreases",
    "Lightheadedness ",
    "Fleece become thin",
    "Skeleten pain",
    "Hind quarted soil",
    "Wound",
    "Watery eye",
    "Excessive eye watering",
    "Scratching",
    "Edema in lower jaw",
    "Lip",
    "Slim over the shell",
    "Moist",
    "Tremors",
    "difficulty breating",
    "Weekness in the back legs",
    "coughing ",
    "Excessive production",
    "Tender to touch",
    "Eventually death",
    "Overweight",
    "Pale comb",
    "loss of appetite",
    "Blood on faces",
    "haemorrhage",
    "Scartching",
    "Bloody droping",
    "Dirty",
    "change their normal behaviour",
    "Blister",
    "Tremor",
    "unable to urinate",
    "Mummification",
    "Back Pain",
    "Raw",
    "feline infections",
    "Salivation",
    "Mortality",
    "High moratality",
    "Abdonormal pain",
    "Thivk skin",
    "Yellowish Discharge",
    "Muscus",
    "Tarry Stool",
    "Snoring",
    "Loss of vitamin E",
    "Intellectual disability",
    "Severe",
    "Watering of eyes",
    "No appp",
    "Redness of white of the eye",
    "Bumps(black,grey or red)",
    "Tremor ",
    "Jaundice",
    "Anoxeria",
    "Crusty",
    "Muscle weakness",
    "Swelling of eyelid",
    "Painfull Swalling",
    "Hairy Fleeces",
    "Papules appear on teats anad udder",
    " pain and bloating",
    "diarrhea",
    "Balance problem",
    "Pustulses",
    "Severe headache",
    "Disharge from affected eye",
    "Bony Lesion",
    "Closed eyes",
    "Reduce milk ",
    "Vomitting",
    "Watery Diarrhea dispropotion",
    "Wool is clumped",
    "foul smelling stools",
    "nausea",
    "Ataxia",
    "Groosly enlarged",
    "Enteritis",
    "Gums",
    "Hyper sensitivity",
    "Sleeping Excessively",
    "self-isolation",
    "Exessive Urination",
    "Change in gait",
    "Easily damage shell",
    "Colic",
    "difficulty swallowing",
    "Polyuria",
    "Floopy muscle",
    "Yellow Eye",
    "Obstructed Lungs",
    "thirst",
    "Neck Vein Swelling",
    "Greenish diarrhea",
    "Hemolytic anemia",
    "Vomiting",
    "Retarded Growth",
    "Flatulence",
    "Severe swellimg",
    "Oedema",
    "abortion",
    "Upset stomach",
    "Puffed_up Feather",
    "Redness ",
    "Septic Arthritis",
    "Most often none",
    "Sores on lower leg and teats",
    "Corneal Ulceration",
    "Swallowing",
    "Difficulty in breathing",
    "Milk getting out more thick",
    "Poor Body condition",
    "Dry or dull hair",
    "Depression",
    "anaemia",
    "Difficult in respiration",
    "Spines",
    "Milk reduce",
    "Exercise in tolerance",
    "Inflammation ",
    "Unilateral Nasal discharge",
    "Redness of eye",
    "inability to rise",
    "Chills",
    "Hyperexcitability",
    "Vitamin and minerals defiency",
    "Lesions on ear",
    "Dyspnea",
    "Week pulse",
    "Skin issue",
    "trembling",
    "Jaw is dropped",
    "Tremors of the head",
    "Production of mucus",
    "Swelling on jaw",
    "Hair tining",
    "Muscles ache",
    "recumbency",
    "Difficulty in Swallowing",
    "Obscure Lameness",
    "Red lesion from bald patches",
    "tiredness",
    "Noisy Breathing",
    "Dark or black face",
    "Scartching ear",
    "Enlarged Thymus",
    "cough",
    "coughing",
    "Hepatitis",
    "Severe weekness and depression",
    "weight loss",
    "Skeleten abnormalities",
    "Barren ewes",
    "Bloody Drool",
    "Dysentery",
    "Inflammation of eye",
    "Death of lamb",
    "Shaking oh head",
    "Good appetite",
    "Hemoglobinuria",
    "Restlessness",
    "Watery Stool",
    "Odor to Ear",
    "restless movement",
    "Purplish combs",
    "outstretched neck",
    "Loss of milk production",
    "listlessness",
    "Fatty stool",
    "Black on ear",
    "Gas",
    "Secondary Infection",
    "Undigested in their feces",
    "Unsteady Gait",
    "Grunting",
    "chirping",
    "Asymptomatic",
    "Pox lesion",
    "Enlarged lymph nodes or Swelling",
    "facial swelling,",
    "Moist and painfull",
    "Stomach  cramps",
    "chewing",
    "changed gait",
    "Viability",
    "Shivering",
    "Lesions in the nasal cavity",
    "Facial paralysis",
    "Poor immune function",
    "Thrist and urination",
    "difficulty moving and eating",
    "Eye ulcer",
    "Attacks",
    "Swelling of face or leg",
    "Reduce Reproductive potential",
    "Cell Damage",
    "Head tossing",
    "Weak Pulse",
    "Difficulty walking",
    "Clearly unthrifty",
    "noisy breathing",
    "Occular discharge",
    "urination problem",
    "lathargy",
    "Folded Ears",
    "Lying on the side",
    "Eye become dull",
    "Lacrimation",
    "dry or tacky gums",
    "Discomfort",
    "Berberi",
    "Bleeding from other parts of the body",
    "Ulcer",
    "Wasting",
    "Ruffled Coat",
    "Throat and Ear pain",
    "Facial defects",
    "Fever",
    "Infection of the skin",
    "Broody behavior",
    "Nasal Discharge",
    "Drop in milk production",
    "Dull",
    "Pyrexia",
    "Poor coat condition",
    "Congestion",
    "Kick",
    "Arthritis",
    "watery eyes",
    "Pawing at bedding",
    "los of the ability to walk",
    "Hematuria",
    "Hemopytsis",
    "weakness",
    "Polydipsa",
    "Coughing",
    "Tremor of head and neck",
    "Sickness",
    "Emaciation",
    "Sour Throat",
    "Flat ribs",
    "Poor condition",
    "loss of tail tone",
    "Swolling of joint",
    "Poor growth",
    "Smell of ammonia",
    "Anversion to light",
    "Broken Bones",
    "Testical Pain",
    "Animal stop feed",
    "Iris prolapse",
    "Nose picking",
    "Severe colic",
    "Stiffness",
    "Oxygen defiency",
    "Small intestines",
    "Rub",
    "Lack of flying",
    "Dribbling of saliva",
    "Dandruff in cat coat",
    "Darkened skin",
    "Pawing at the face or nose",
    "Difficulty in Walk",
    "Nause",
    "Sweat",
    "swelling",
    "Wattles",
    "Runny nose",
    "Urine infection",
    "Tail shaking",
    "Increased in breathing",
    "Abnormal conformation",
    "diffuse",
    "Ruffled Appearance",
    "Red skin",
    "Lameness",
    "Watery Eyes",
    "Dizziness",
    "Abnormally long leg",
    "Respiratory infection",
    "Isolation from flock",
    "Shallow breathing",
    "Fatigue",
    "Stained Wool",
    "Nible at their wool",
    "Diffulty chewing",
    "Sheep often bites",
    "Liquid Dropping",
    "dizziness and fainting",
    "Scratches",
    "Excessive food intake",
    "Wheezing",
    "Fluffed Feather",
    "Pain on face",
    "Lack of coordination",
    "Excession Salivation",
    "Clouded cornea",
    "Wool loss",
    "Bloody diarrhea",
    "Eye redness",
    "Stillbirth",
    "Trembling",
    "Rapid Heart Rate",
    "Wool production",
    "Staggering",
    "Staggering as drunk",
    "Pox lession on skin",
    "Blue Eye",
    "Indigestion",
    "Gagging",
    "Pale gums",
    "Skin infection",
    "Inability to digest",
    "Fetopelvic dispropotion",
    "Size of lesions vary",
    "Gasc",
    "Profuse",
    "Blood in urine",
    "Itchiness",
    "Foul Breath",
    "Excessive drooling",
    "loss of alertness",
    "Fluif filled blisters",
    "Loss of eye",
    "Black stool",
    "vomiting",
    "Air sacculitis",
    "Hyperesthesia",
    "Bleeding wounds",
    "Enlarged skulls",
    "Twitching",
    "Bottle jaw",
    "Yellow or green dropping",
    "Difficulty in rising",
    "lameness",
    "Facial Paralysis",
    "Blue colored lip",
    "Gasping",
    "Pneumonia ",
    "Anemia",
    "Inflammed eye",
    "Flank",
    "Shyness or aggression",
    "Abortion",
    "swollen teats",
    "Shortness of breath",
    "sweating",
    "Chest Pain",
    "Pains to Walk",
    "fluffed feathers",
    "Skin rashes",
    "Stomach cramps",
    "abscessess",
    "Scartch",
    "Ulcers",
    "Loss of  appetite",
    "Signs in ewe",
    "Very cold skin",
    "abnormalalities",
    "Self Mutilation",
    "Formation of vesicles",
    "Crusting of the skin",
    "Muscle pain",
    "Milk getting out more watery",
    "Dry Hair coat",
    "Strong cough",
    "Distress",
    "high temperature",
    "Fatique",
    "Swollen kidney",
    "Dilation of duodenum",
    "heavy breathing",
    "Skin reashes",
    "Blood in faces",
    "Skin irritation",
    "Itches",
    "Gas or bloating",
    "Flaking of the Scutes",
    "Inability to stand ",
    "Prostrat",
    "Scabs",
    "Poor wool",
    "Dry skin",
    "Muscular Spasms",
    "Nasal",
    "Abortion ",
    "Tensemus",
    "Halitosis",
    "Neurologic sign",
    "Red patches",
    "Nervous",
    "Slow growth",
    "Despression",
    "Tear produce",
    "Nervous Issue",
    "Drooping wings",
    "Bubbles in the mouth",
    "Cessation of eructation",
    "SkinAllergy",
    "Skin may thicken",
    "stumbling",
    "Respiratory distress",
    "Facial Swelling",
    "Watering Diarrhea",
    "Animal become lame",
    "Joint Pain",
    "Defienciency in vitamin",
    "Normal appetite",
    "Sudden Death",
    "lllthrift",
    "Hair loss",
    "Flabby",
    "Stripped remiges",
    "stomatitis",
    "Red and inflammation ear",
    "Beak overgrowth",
    "Cramps",
    "Eyeproblem",
    "Skin color change",
    "Aversion to light",
    "Nervousness",
    "Difficulty in Breathing",
    "Loss of powder down",
    "Difficulty breathing",
    "Headache",
    "Swelling of head and neck",
    "dull ness",
    "Loss od appetite",
    "fever",
    "Inability to jump",
    "Sensitive to touch",
    "droopiness",
    "Bleeding from the nose",
    "Regurgitation of food",
    "Mild sneezing",
    "Blood Clots",
    "wasting",
    "Diarrhea",
    "Animal gets uneasy",
    "Rough Hair coat",
    "inappetence",
    "Swelling  in the bite area",
    "Dry air",
    "Constant pacing",
    "Edematous",
    "Less Feather growth",
    "gasping for air",
    "Red Diarrhea",
    "Faeces are streake with blood",
    "Semen Examination",
    "paresis",
    "Diphtherictic",
    "Blood from mouth",
    "depression",
    "morbidity",
    "Acting aggressive",
    "Reduce growth",
    "Lying down",
    "Tail Wagging",
    "Changes in outer layer skin",
    "Hyperaestesia",
    "Reduce Lamp marking",
    "Bloody Diarrhea",
    "panting",
    "Yellow in beak",
    "high body temperaure",
    "twisted neck",
    "Lame",
    "Ulcerated ear",
    "Dark colored bloody",
    "Wether restless",
    "slow growth",
    "Sudden Abortion",
    "Effort to breath",
    "Swollen",
    "Paralyzed leg",
    "Lesion",
    "Nosebleed ",
    "Dehydration",
    "Forthy eye",
    "Discharge",
    "Bottle Jaw",
    "Nose Bleeds",
    "Swollen lymph nodes",
    "Legness",
    "Hot joints",
    "emaciation",
    "Red eye",
    "Dry Scabs",
    "muscular stiffness",
    "Dullness",
    "Weekness",
    "Blood in stool",
    "Hydrophobia",
    "Vision Problem",
    "Sick",
    " dizziness and fainting",
    "Small and yellow bumps",
    "Aggressiveness",
    "Stamping And pedding of hind eye",
    "Enlargement of bones",
    "Swelling of neck",
    "Redness on ear",
    "Infected navels",
    "Bleeding in eye and skin",
    "Achomotrica",
    "Straining",
    "Dejection",
    "Eye closed",
    "gurgling sound",
    "Rapid Breathing",
    "Relunctance to move",
    "Agalactia",
    "experiencing changes in weight",
    "ruffled feathers",
    "Signs in rams",
    "Loss of appetite",
    "Walking problem",
    "Wandering",
    "Poor coat apperence ",
    "pain ",
    "swollen",
    "sneeze",
    "Foot Hot",
    "pulmonary congestion",
    "Decresed egg production",
    "Muscle twiching",
    "Weakness",
    "head tilt",
    "Extension of neck",
    "Kicking at the belly",
    "muscles problem",
    "Ear infection",
    "Grinding of teeth",
    "paralysis",
    "Trauma",
    "Lesions on nose",
    "Death",
    "Small red bumps",
    "Neck paralysis",
    "Sneezing",
    "Poor appetite",
    "Scabs on lip",
    "Decrease in milk production",
    "Abdominal pain",
    "Red Tinge",
    "Attack",
    "Excess salivary",
    "Lepatomegaly",
    "Immediate death",
    "Heat",
    "inflamed nostrils",
    "Speech delay",
    "Inability to absorb nutrients",
    "Discharge from eye",
    "Scabbing",
    "Retained Placenda",
    "Neurologic abnormalities",
    "Join pains",
    "Lession on cat skin",
    "Conjunctive",
    "congestion",
    "Enlarged lymph nodes",
    "Bald patches",
    "Unable to exercise",
    "Wart-like growth",
    "Itching",
    "Tail_Bobbing",
    "Preening",
    "Scaly skin",
    "Pharyngitis",
    "Blue straws",
    "change in milk",
    "Excess salivation",
    "Horny growth",
    "Tenderness",
    "sudden death",
    "Shock",
    "Stopped eat",
    "swollen abdomen",
    "Inappentence",
    "Mouth lesion",
    "Skin Rashes",
    "Lession on the skin",
    "mild weakness",
    "Swelling may occur under jaw",
    "Grinding teeth",
    "Bloody in feather",
    "Muscle Loss",
    "Apathy",
    "loss of wariness",
    "Wound lesion",
    "Lack of walking",
    "Nostrils",
    "Continuous loss of weight",
    "anorexia",
    "Clubbed Feather",
    "Mucus discharge from the eye",
    "Drooping ears",
    "weakened legs",
    "Retching",
    "Distended stomach",
    "eye discharges",
    "Neck Paralysis",
    "respiratory noise",
    "Decreased milk",
    "Fast breathing",
    "Recumbency",
    "Less Eat",
    "Terminal convulsion",
    "Weight gain",
    "Tiredness",
    "Warm",
    "Swelling of joints",
    "Swollen and painfull",
    "Extreme thirst",
    "Eye disharge",
    "Incoordination",
    "Milky Hard",
    "drooping ears",
    "urine dribbling",
    "Swelling",
    "stunted growth",
    "gasping for breath",
    "Swollen Abdomen",
    "Spread of infection",
    "bleeding from wounds",
    "Muscle stiffness",
    "Allergic Reaction",
    "Inflammation",
    "Half-closed eye",
    "Loss of earing",
    "Stand with head droping",
    "Discharge From eyes",
    "loss in weight",
    "confusion",
    "Eye and Skin change",
    "cough ",
    "Carcass decomposes",
    "Weight loss",
    "Fluif Faeces on blood and muscle",
    "Unable To Eat",
    "Progressive weakness",
    "Tachypea",
    "Swelling of internal organs",
    "Rhinitis",
    "Rough coat",
    "Discharge ",
    "Eye movements",
    "Bad smell",
    "burning ache or pain",
    "Difficulty in walking",
    "frequent yawning",
    "Listlessness",
    "lack of appetite",
    "Cloacal pasting",
    "Partial Paralysis",
    "Decrease appetite",
    "Sweats",
    "Thicked skin",
    "Drop on egg production",
    "Bloody Diarhhea",
    "Conjuctivtis",
    "Passing of undigested food",
    "high body temperature",
    "Difficulty in feeding",
    "Straw colored",
    "Willnot run to jump",
    "Head ache",
    "Jerky limb movements",
    "Endomeritis",
    "Nasal discharge",
    "Diarrhea with muscus",
    "Decreased growth of bone",
    "Bloody",
    "Consistency of milk",
    "Pruritis",
    "Salivating",
    "Loss of wool",
    "Ulcerated skin",
    "Attempt to urinate",
    "Lound breathing",
    "Abnormalities",
    "Edema",
    "Watering",
    "Blood Poisioning ",
    "Appetite varies",
    "Skin colour change",
    "undernutrition",
    "diarrhoea",
    "Nuerological",
    "Body stiffness",
    "Excessive blood loss",
    "mild colic",
    "muscular spasms",
    "Hepatic failure",
    "Kid moratality",
    "Egg production stops",
    "Seizuers",
    "Loss of pigment",
    "Distinctive bumps",
    "Shortness of breath.",
    "Swelling of udder",
    "Chronic eye inflamation",
    "Epistaxis",
    "Periodic vommiting",
    "Hoarseness",
    "Exhaustion",
    "Rubbing eye",
    "Lesions ",
    "hot udder",
    "Loss of eat",
    "Scartches",
    "Aneamia",
    "Flaky",
    "Swelling ",
    "Redness",
    "Urination",
    "Diffulty Swallowing",
    "Abdonormal discomfort",
    "Reluctant Move",
    "Kidney failure",
    "Strange behaviour",
    "lying down",
    "Blooody Fluid",
    "Head tilt",
    "Swelling on theBody",
    "Sharp Feather",
    "Diffculty breathing",
    "Swollen Belly",
    "Bad breath",
    "Heavy Breathing",
    "Decreased eyelid",
    "Abortion on late pregancy",
    "Uteria inertia",
    "Blindness",
    "Red on affected area",
    "Sluggish",
    "Excessive grooming",
    "Pnemonia",
    "Circling",
    "Swelling on joints",
    "Head Pressing",
    "Lossened Teeth",
    "Seizures",
    " rapid heartbeats",
    "Sudden death",
    "difficulty diagnosis",
    "Slightly Swollen",
    "Skin ulcer",
    "Stealing ",
    "Appetite",
    "Fell unwell",
    "Greenish-yellow nasal discharge",
    "Sensitivity to bright light",
    "Blood stool",
    "Weigth bearing long bones",
    "Facial swelling",
    "Nesting behaviour",
    "Teeth griding",
    "Weak kids",
    "Anorexia",
    "Crusty eye lashes and matting of eyelashes",
    "Lethargy",
    "Limping",
    "lack of vocalizations",
    "Flock Moratality",
    "Acting unnaturally tame",
    "red-colored ",
    "inability to fly",
    "Swaying",
    "Succumb",
    "stop drinking",
    "Drooling",
    "Pains",
    "stop eating",
    "Ruffled feathers",
    "Relunctance to walk",
    "Weightloss",
    "Difficult in walking",
    "Abdominal discomfort",
    "Feather Loss",
    "Scabs On feet",
    "Listless",
    "Dandruff",
    "Difficultty in Breathing",
    "Mucous discharge",
    "Bite other animals",
    "Discharge from ear",
    "Smell",
    "Mammary glads",
    "Swollen comb",
    "Uncharacteristic hiding",
    "Raised growth or bump",
    "Misshapen Beak",
    "decreased stool production"
  ];